import { handlePostRequest } from "../hooks/api";

export async function postComments({ postid, comment, commentPhoto, parentid }) {
  const endpoint = "/posting/addCommentInPosting";

  const formData = new FormData();
  formData.append("postid", postid);
  formData.append("comment", comment);
  if (commentPhoto) formData.append("commentPhoto", commentPhoto);
  if (parentid) formData.append("parentid", parentid);

  const response = await handlePostRequest(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function getComments(postid) {
  const requestBody = { postid: postid };

  const endpoint = "/posting/getComments";
  const response = await handlePostRequest(endpoint, requestBody, {}, false);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function removeComments(postid) {
  const requestBody = { commentid: postid };

  const endpoint = "/posting/removeCommentFromPosting";
  const response = await handlePostRequest(endpoint, requestBody, {}, false);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function toggleCommentLike(commentId) {
  const endpoint = `/posting/comments/${commentId}/like`;
  const response = await handlePostRequest(endpoint, {}, {}, false);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function getCommentLikes(commentId, userid) {
  const requestBody = { userid: userid };
  const endpoint = `/posting/comments/${commentId}/likes`;
  const response = await handlePostRequest(endpoint, requestBody, {}, false);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}